import { css, DefaultTheme } from "styled-components";
import { hexToRGB } from "@shared/utils/misc";

/** New look: placeholders stay legible on dark surfaces too. */
export const getNewLookPlaceholderColor = (theme: DefaultTheme) =>
  theme.isDarkMode
    ? hexToRGB(theme.colors.secondaryText, 0.65)
    : theme.colors.lightestText;

export const inputBox = css<{ $bgColor?: string }>`
  background: ${(p) => p.$bgColor || p.theme.colors.cardBgColor};
  color: ${(p) => p.theme.colors.primaryGrey};
  border: 1px solid ${(p) => p.theme.colors.lightBorderGrey};
  border-radius: 6px;
  ${(p) =>
    p.theme.isNewLook &&
    css`
      border-radius: ${p.theme.radii.control}px;
    `}
`;

/**
 * New-look field states: the border darkens on hover and turns blue, with a
 * soft ring, only while the field has focus.
 */
export const newLookFieldStates = css`
  border-color: ${(p) => p.theme.colors.lightBorderGrey};
  box-shadow: none;
  transition: border-color 150ms, box-shadow 150ms;
  &:hover {
    border-color: ${(p) => p.theme.colors.mediumBorderGrey};
  }
  &:focus,
  &:focus-within {
    border-color: ${(p) => p.theme.colors.primaryBlue};
    box-shadow: 0 0 0 3px ${(p) => hexToRGB(p.theme.colors.primaryBlue, 0.14)};
  }
`;

// Lucide line icons as CSS mask images, for glyphs Ant Design draws itself.
const lucideMask = (paths: string, strokeWidth = 2) =>
  `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='${strokeWidth}' stroke-linecap='round' stroke-linejoin='round'%3E${paths}%3C/svg%3E")`;

export const NEW_LOOK_CHECK_ICON = lucideMask(
  "%3Cpath d='M20 6 9 17l-5-5'/%3E",
  2.25
);
export const NEW_LOOK_ARROW_RIGHT_ICON = lucideMask(
  "%3Cpath d='M5 12h14'/%3E%3Cpath d='m12 5 7 7-7 7'/%3E",
  1.75
);
export const NEW_LOOK_X_ICON = lucideMask(
  "%3Cpath d='M18 6 6 18'/%3E%3Cpath d='m6 6 12 12'/%3E",
  2
);

/** Replaces an Ant Design glyph (its inner svg) with a lucide mask icon. */
export const newLookMaskIcon = (icon: string, size: number) => css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  > svg {
    display: none;
  }
  &::before {
    content: "";
    display: block;
    width: ${size}px;
    height: ${size}px;
    background-color: currentColor;
    -webkit-mask: ${icon} center / contain no-repeat;
    mask: ${icon} center / contain no-repeat;
  }
`;
